module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "main-content"
    }
  }, [(!_vm.examResults) ? _c('div', [(_vm.examExercises && _vm.examExercises.exam && _vm.examExercises.exam.show_one_exercise) ? _c('div', [(!_vm.afterLastExercise) ? _c('div', [_c('exercises-list', {
    attrs: {
      "examExercises": [_vm.examExercises.exercises[_vm.indexOfCurrentExercise]],
      "indexOffset": _vm.indexOfCurrentExercise,
      "exercisesNumber": _vm.examExercises.exercises.length
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-right text-muted"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.exams.nextExerciseIn')) + " " + _vm._s(Math.floor(Math.min(_vm.timeForThisExercise, _vm.examExercises.timeLeft / 1000))) + " " + _vm._s(_vm.$t('pages.exams.seconds')) + "\n            "), _c('button', {
    staticClass: "btn btn-primary btm-sm",
    on: {
      "click": _vm.continueToNextExercise
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.continueNextExercise')))])]), _vm._v(" "), _c('br')], 1) : _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticStyle: {
      "width": "250px",
      "height": "250px"
    },
    attrs: {
      "src": "/static/logoBW.png"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('pages.exams.endOfExam')))])])]) : _c('div', [_c('exercises-list', {
    attrs: {
      "examExercises": _vm.examExercises.exercises
    }
  })], 1)]) : (_vm.examExercises.examExercises) ? _c('exercises-list', {
    attrs: {
      "examExercises": _vm.examExercises.examExercises
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.examExercises && _vm.examExercises.exam && _vm.examExercises.exam.show_one_exercise) || _vm.afterLastExercise) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "id": "finish-modal",
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showModalForfinish($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.finish')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.examExercises.timeLeft && !_vm.jeAdmin) ? _c('div', {
    staticClass: "examTimer"
  }, [_c('div', {
    staticClass: "panel-group"
  }, [_c('div', {
    class: ['panel', (_vm.examExercises.timeLeft < 30000 && Math.floor(_vm.examExercises.timeLeft / 1000) % 2 === 0) ? 'panel-danger' : 'panel-default']
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapse1"
    }
  }, [(_vm.timeCollapsed) ? _c('span', [_c('i', {
    staticClass: "fa fa-hourglass-end"
  })]) : _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.timeLeft')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.examExercises && _vm.examExercises.exam && _vm.examExercises.exam.show_one_exercise) ? _c('div', [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$t('pages.exams.timeForThisExercise')))]), _c('br'), _vm._v(" "), (Math.min(_vm.timeForThisExercise, _vm.examExercises.timeLeft / 1000) > 60) ? _c('span', [_vm._v(_vm._s(Math.floor(Math.min(_vm.timeForThisExercise, _vm.examExercises.timeLeft / 1000) / 60)) + " " + _vm._s(_vm.$t('pages.exams.minutes')) + " ")]) : _vm._e(), _vm._v("\n                  " + _vm._s((Math.floor(Math.min(_vm.timeForThisExercise, _vm.examExercises.timeLeft / 1000))) % 60) + " " + _vm._s(_vm.$t('pages.exams.seconds'))), _c('br'), _vm._v(" "), (_vm.seated) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.seatingPosition')) + ": "), _c('a', [_vm._v(_vm._s(_vm.selectedSeat))])]) : _vm._e()]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('pages.exams.timeForExam')))]), _c('br'), _vm._v(" "), (_vm.examExercises.timeLeft / 1000 > 60) ? _c('span', [_vm._v(_vm._s(Math.floor(_vm.examExercises.timeLeft / 1000 / 60)) + " " + _vm._s(_vm.$t('pages.exams.minutes')) + " ")]) : _vm._e(), _vm._v("\n                " + _vm._s((Math.floor(_vm.examExercises.timeLeft / 1000)) % 60) + " " + _vm._s(_vm.$t('pages.exams.seconds'))), _c('br'), _vm._v(" "), (_vm.seated) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.seatingPosition')) + ": "), _c('a', [_vm._v(_vm._s(_vm.selectedSeat))])]) : _vm._e()]) : _c('div', [(_vm.examExercises.timeLeft > 60000) ? _c('span', [_vm._v(_vm._s(Math.floor(_vm.examExercises.timeLeft / 1000 / 60)) + " " + _vm._s(_vm.$t('pages.exams.minutes')) + " ")]) : _vm._e(), _vm._v("\n                " + _vm._s((Math.floor(_vm.examExercises.timeLeft / 1000)) % 60) + " " + _vm._s(_vm.$t('pages.exams.seconds'))), _c('br'), _vm._v(" "), (_vm.seated) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.seatingPosition')) + ": "), _c('a', [_vm._v(_vm._s(_vm.selectedSeat))])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-finish-exercises"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-primary"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.finish')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.areYouSure')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.examinationInfo')) + ":")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(_vm.$t('pages.exams.timeLeft')) + ": "), (_vm.examExercises.timeLeft > 60000) ? _c('span', [_vm._v(_vm._s(Math.floor(_vm.examExercises.timeLeft / 1000 / 60)) + " " + _vm._s(_vm.$t('pages.exams.minutes')) + " ")]) : _vm._e(), _vm._v("\n                  " + _vm._s((Math.floor(_vm.examExercises.timeLeft / 1000)) % 60) + " " + _vm._s(_vm.$t('pages.exams.seconds'))), _c('br'), _vm._v(" "), (_vm.examInfo.maxRetries > 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.allowedAttempts')) + ": " + _vm._s(_vm.examInfo.maxRetries)), _c('br')]) : _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.allowedAttempts')) + ": " + _vm._s(_vm.$t('pages.exams.noLimit'))), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.thisAttemptNumber')) + ": " + _vm._s(_vm.examExercises.retriesCount))]), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.exercisesList')) + ":")])]), _vm._v(" "), _vm._l((_vm.examExercises.exercises), function(exercise, index) {
    return (exercise) ? _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(_vm.$t("pages.exercise.name") + " " + (index + 1)) + "\n                  "), _c('ul', _vm._l((exercise.questions), function(question, i) {
      return _c('li', [_vm._v(" " + _vm._s(_vm.$t("pages.exams.question")) + " " + _vm._s(i + 1) + ":\n                      "), (question.submittedAnswer) ? _c('span', {
        staticClass: "label label-success"
      }, [_vm._v(_vm._s(_vm.$t("pages.exams.answered")))]) : _c('span', {
        staticClass: "label label-warning"
      }, [_vm._v(_vm._s(_vm.$t("pages.exams.notAnswered")))])])
    }), 0)])]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer bg-primary"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.buttons.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.finishExam($event)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('pages.buttons.confirm')) + " ")])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bf3f6cba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf3f6cba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/ExamExercise.vue
// module id = 1470
// module chunks = 1